// index

let dt_references = null;
let dt_imports = null;

export function index(){

    dt_references = $('#references_table').DataTable({
        ajax: {
            url: $('#references_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_reference_actions },
            { width: '120', data: 'ean', orderable: true, searchable: true },
            { data: 'name', orderable: true, searchable: true },
            { width: '45', data: 'stock', orderable: true, searchable: true, defaultContent: '', class: 'text-right', render: render_stock },
            { width: '60', data: 'units_per_box', orderable: true, searchable: false, defaultContent: '', class: 'text-right' },
            { width: '60', data: 'boxes_per_pallet', orderable: true, searchable: false, defaultContent: '', class: 'text-right' },
            { width: '55', data: 'purchases[0].price', orderable: true, searchable: false, class: 'text-right', render: datatables.render_price, defaultContent: '' },
            { width: '50', data: 'purchases[0].date', orderable: true, searchable: false, class: 'text-right', render: datatables.render_date },
            { width: '55', data: 'sales[0].price', orderable: true, searchable: false, class: 'text-right', render: datatables.render_price, defaultContent: '' },
            { width: '50', data: 'sales[0].date', orderable: true, searchable: false, class: 'text-right', render: datatables.render_date },
            { width: '120', data: 'updated_at', orderable: true, searchable: false, render: datatables.render_datetime }
        ],
        order: [[2, 'asc']],
        pageLength: 50,
    });

    // Add event handlers for batch actions
    dt_references.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="add_categories"]').click(batch_add_categories);
        $(settings.nTableWrapper).find('.table_batch_actions [action="remove_categories"]').click(batch_remove_categories);
    });

    dt_imports = $('#imports_table').DataTable({
        ajax: {
            url: $('#imports_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_import_actions },
            { width: '120', data: 'created_at', orderable: true, searchable: false, render: datatables.render_datetime },
            { data: 'filename', orderable: true, searchable: true },
            { width: '80', data: 'status', orderable: false, searchable: false, defaultContent: '', render: render_import_status },
            { width: '120', data: 'updated_at', orderable: true, searchable: false, render: datatables.render_datetime }
        ],
        order: [[1, 'desc']],
        pageLength: 50,
    });

}

function render_stock(data, type, row){

    if(parseInt(data) == 0){
        return '';
    }

    return new Intl.NumberFormat(window._locale, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }).format(data);

}

function render_import_actions(data, type, row){
    const url_info = ($("#imports_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}

function render_import_status(data, type, row){

    switch(row.status){
        case 'pending':
            return '<span class="badge bg-info">' + window.__('pendiente') + '</span>';
        case 'processing':
            return '<span class="badge bg-primary">' + window.__('en proceso') + '</span>';
        case 'completed':
            return '<span class="badge bg-success">' + window.__('completado') + '</span>';
        case 'failed':
            return '<span class="badge bg-danger">' + window.__('error') + '</span>';
    }

    return ''; // unrecognized status

}

// show

let dt_import_results = null;

export function show(){

    // datatable results
    
    dt_import_results = $('#import_results_table').DataTable({
        ajax: {
            url: $('#import_results_table').attr('url'),
        },
        columns: [
            { width: 50, data: 'row', orderable: true, searchable: true },
            { width: 120, data: 'ean', orderable: false, searchable: true, defaultContent: '' },
            { data: 'status', orderable: false, searchable: false, defaultContent: '', render: render_import_result_status },
        ],
        order: [[0, 'asc']],
    });

    let status = $('#import_status').length ? $('#import_status').attr('status') : null;
    if(
        status == 'pending' 
        || status == 'processing'
    ){
        setInterval(function(){
            $.ajax({
                url: $('#import_status').attr('url'),
                method: 'GET',
                success: function(response){
                    if(response.status != status){
                        location.reload();
                    }
                }
            });
        }, 5000);
    }

}

function render_import_result_status(data, type, row){

    let status = row.status.split(',');
    let badges = '';

    status.forEach(s => {
        switch(s.trim()){
            case 'created':
                badges += '<span class="badge bg-success me-1 mr-1">' + window.__('referencia creada') + '</span>';
                break;
            case 'updated':
                badges += '<span class="badge bg-success me-1 mr-1">' + window.__('stock actualizado') + '</span>';
                break;
            case 'purchase_created':
                badges += '<span class="badge bg-success me-1 mr-1">' + window.__('compra creada') + '</span>';
                break;
            case 'purchase_updated':
                badges += '<span class="badge bg-success me-1 mr-1">' + window.__('precio de compra actualizado') + '</span>';
                break;
            case 'sale_created':
                badges += '<span class="badge bg-success me-1 mr-1">' + window.__('venta creada') + '</span>';
                break;
            case 'sale_updated':
                badges += '<span class="badge bg-success me-1 mr-1">' + window.__('precio de venta actualizado') + '</span>';
                break;
            case 'invalid_ean':
                badges += '<span class="badge bg-warning me-1 mr-1">' + window.__('código no válido') + '</span>';
                break;
            case 'exception':
                badges += '<span class="badge bg-danger me-1 mr-1">' + window.__('error') + ': ' + row.exception + '</span>';
                break;
        } 
    });

    return badges;

}

function render_reference_actions(data, type, row){
    const url_info = $("#references_table").attr('url_info') ?? '';
    if(url_info === '') return '';
    
    const info_url = url_info.replace('#', row.id);
    
    const actions = 
    '<div class="btn-group" role="group">' +
    '   <a class="btn btn-primary btn-xs show ajax" href="' + info_url + '">' + window.__('info') + '</a>' +
    '</div>';
    
    return actions;
}

function batch_add_categories(){
    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    
    let references_id = [];
    $.each(rows_selected, function(index, rowId){
        references_id.push(rowId);
    });
    
    if(references_id.length == 0){
        window.messages.error(__('No has seleccionado ninguna referencia'));
    } else {
        $('#add-categories-modal input[name="reference_ids"]').val(references_id.join(','));
        $('#add-categories-modal select[name="category_ids[]"]').val(null).trigger('change');
        $('#add-categories-modal').modal('show');
    }
}

function batch_remove_categories(){
    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    
    let references_id = [];
    $.each(rows_selected, function(index, rowId){
        references_id.push(rowId);
    });
    
    if(references_id.length == 0){
        window.messages.error(__('No has seleccionado ninguna referencia'));
    } else {
        $('#remove-categories-modal input[name="reference_ids"]').val(references_id.join(','));
        $('#remove-categories-modal select[name="category_ids[]"]').val(null).trigger('change');
        $('#remove-categories-modal').modal('show');
    }
}

export function updated_categories_reload(){
    $('#add-categories-modal').modal('hide');
    $('#remove-categories-modal').modal('hide');
    dt_references.ajax.reload();
}

// show_reference

let dt_categories = null;
let dt_providers = null;

export function show_reference(){
    
    dt_categories = $('#categories_table').DataTable({
        ajax: {
            url: $('#categories_table').attr('url'),
        },
        columns: [
            { width: '70', data: null, orderable: false, searchable: false, class: 'actions', render: render_categories_actions },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [[1, 'asc']],
        pageLength: 50,
    });

    dt_categories.on('draw', function(e, settings){
        $(settings.nTableWrapper).find('.toggle_assign').click(toggle_assign_category);
    });

    dt_providers = $('#providers_table').DataTable({
        ajax: {
            url: $('#providers_table').attr('url'),
        },
        columns: [
            { width: '50', data: null, orderable: false, searchable: false, class: 'actions', render: render_providers_actions },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [[1, 'asc']],
        pageLength: 50,
    });

}

function render_categories_actions(data, type, row){

    let actions = '<div class="btn-group" role="group">';
    if(row.assigned){
        actions += '   <a class="btn btn-success btn-xs toggle_assign" category_id="' + row.id + '">' + window.__('asignada') + '</a>';
    } else {
        actions += '   <a class="btn btn-light btn-xs toggle_assign" category_id="' + row.id + '">' + window.__('asignar') + '</a>';
    }
    actions += '</div>';
    
    return actions;
}

function toggle_assign_category(){

    const category_id = $(this).attr('category_id');
    const route = ($("#categories_table").attr('url_info') ?? '').replace('#', category_id);

    if(route != ''){
        window.ajax.post(route);
    }

}

export function categories_reload(){
    
    dt_categories.ajax.reload();

}

function render_providers_actions(data, type, row){
    const url_info = ($("#providers_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;
}